import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FromToFilter, useEventHistory } from "../../../api";
import { BaseCard } from "../../BaseCard";
import { BeaconEventDrawer } from "./EventDrawer";
import { BeaconEventTable } from "./EventTable";

interface BeaconEventCardProps {
  beaconSerial: string;
  selectedFromToFilter: FromToFilter & { from?: Date; to?: Date };
}

export function BeaconEventCard({
  beaconSerial,
  selectedFromToFilter,
}: BeaconEventCardProps) {
  const [eventDrawerVisible, setEventDrawerVisible] = useState(false);
  const { t } = useTranslation();

  const eventHistory = useEventHistory(beaconSerial, selectedFromToFilter);

  const handleDrawerOpenClose = (state: boolean) => {
    setEventDrawerVisible(state);
  };

  return (
    <BaseCard title={t("beacon:events")} allowScroll={true}>
      <BeaconEventTable eventHistory={eventHistory} />
      <BeaconEventDrawer
        eventHistory={eventHistory}
        eventDrawerVisible={eventDrawerVisible}
        onCloseDrawer={handleDrawerOpenClose}
      />
      <Button
        aria-label="show-drawer-button"
        className="show-card-drawer-button"
        type="primary"
        onClick={() => handleDrawerOpenClose(true)}
        icon={<PlusOutlined />}
      />
    </BaseCard>
  );
}
